import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import styles from './Footer.module.scss';
import { additionalInfoLinks, authorsLink } from '../../../../modules/website/components/MainPageLeftBar/dumpBarInfo';

export default function Footer() {
	return (
		<footer>
			 <Container className="px-5 py-3">
			 	<div style={{ width: '100%', backgroundColor: '#C8C6C7', height: '1px', marginLeft: 'auto', marginRight: 'auto'}}></div>
				 <Row className="my-5 text-start">
					<h3 className="mt-5 font-weight-bold mb-5 text-center pb-4">
						<a href="https://apee.org" target="_blank" rel="noopener noreferrer">
							The Association of Private Enterprise Education 
						</a>
					</h3>
					<Col xs={12} lg={3} className="d-flex flex-column align-items-lg-end align-items-center text-lg-end text-center">
						<h4 className="font-weight-bold pb-2">Benjamin Powell</h4>
						<p style={{ lineHeight: '2.2' }}>
						<em>Secretary/Treasurer</em> <br />
						Texas Tech University <br />
						Free Market Institute, Box 45059 <br />
						Lubbock, TX 79409-5059 <br />
						Email: <a href="mailto:apee@ttu.edu">apee@ttu.edu</a>
						</p>
					</Col>
					<Col xs={1} className="mt-5 d-flex justify-content-center">
						<div
						style={{
							width: '1px',
							backgroundColor: '#C8C6C7',
							height: '100%',
						}}
						></div>
					</Col>
					<Col xs={12} lg={3} className="d-flex flex-column align-items-lg-start align-items-center text-lg-start text-center">
							<h5 className={`${styles.footer_title} text-lg-start text-center`}>Additional Information</h5>
								<ul className={`${styles.footer_links} text-lg-start text-center`}>
									{additionalInfoLinks.map((link, index) => (
										<li key={index}>
											<a href={link.url} className={styles.footer_link}>{link.label}</a>
										</li>
									))}
							</ul>
					</Col>
				
					<Col xs={12} lg={4} className="d-flex flex-column align-items-lg-start align-items-center text-lg-start text-center">
							<h5 className={`${styles.footer_title} text-lg-start text-center`}>Authors</h5>
								<ul className={`${styles.footer_links} text-lg-start text-center`}>
									{authorsLink.map((link, index) => (
										<li key={index}>
											<a href={link.url} className={styles.footer_link}>{link.label}</a>
										</li>
									))}
							</ul>
					</Col>
					</Row>

					<div style={{ width: '100%', backgroundColor: '#C8C6C7', height: '1px', marginLeft: 'auto', marginRight: 'auto'}}></div>

					<div className="m-4 pt-3"> 
						<div className="text-center" style={{ fontSize: '12px' }}>
						The content of this website is available under Creative Commons License{' '}
						<a
							href="https://creativecommons.org/licenses/by-nc/3.0/"
							target="_blank"
							rel="noopener noreferrer"
							style={{ color: 'black', textDecoration: 'underline' }}
						>
							Attribution-Noncommercial 3.0 Unported
						</a>{' '}
						|{' '}
						<a
							href="/login"
							target="_blank"
							rel="noopener noreferrer"
							className={styles.login}
							style={{ color: 'black' }}
						>
							Log in
						</a>{' '}
						|{' '}
						<a
							href="https://glifos.com/library"
							target="_blank"
							rel="noopener noreferrer"
							className={styles.links}
							style={{ color: 'black' }}
						>
							Powered by GLIFOS digital archive
						</a>
						</div>
					</div>
					


	  		</Container> 
		</footer>
	);
}
